"use strict";
var Ajaxinate = function (t) {
  var e = t || {};
  (this.settings = Object.assign(
    {
      pagination: "#pagination-wrapper",
      method: "scroll",
      container: "#product-grid",
      offset: 1000,
      loadingText: "טוען...",
      callback: null,
    },
    e
  )),
    (this.addScrollListeners = this.addScrollListeners.bind(this)),
    (this.addClickListener = this.addClickListener.bind(this)),
    (this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)),
    (this.stopMultipleClicks = this.stopMultipleClicks.bind(this)),
    (this.destroy = this.destroy.bind(this)),
    (this.containerElement = document.querySelector(this.settings.container)),
    (this.paginationElement = document.querySelector(this.settings.pagination)),
    this.initialize();
};
(Ajaxinate.prototype.initialize = function () {
  this.containerElement &&
    {
      click: this.addClickListener,
      scroll: this.addScrollListeners,
    }[this.settings.method]();
}),
  (Ajaxinate.prototype.addScrollListeners = function () {
    this.paginationElement &&
      (document.addEventListener("scroll", this.checkIfPaginationInView),
      window.addEventListener("resize", this.checkIfPaginationInView),
      window.addEventListener(
        "orientationchange",
        this.checkIfPaginationInView
      ));
  }),
  (Ajaxinate.prototype.addClickListener = function () {
    this.paginationElement &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
      (this.clickActive = !0),
      null !== this.nextPageLinkElement &&
        this.nextPageLinkElement.addEventListener(
          "click",
          this.stopMultipleClicks
        ));
  }),
  (Ajaxinate.prototype.stopMultipleClicks = function (t) {
    t.preventDefault(),
      this.clickActive &&
        ((this.nextPageLinkElement.innerHTML = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        (this.clickActive = !1),
        this.loadMore());
  }),
  (Ajaxinate.prototype.checkIfPaginationInView = function () {
    this.paginationElement = document.querySelector(this.settings.pagination);
    if (!this.paginationElement) return false;
    var t =
        this.paginationElement.getBoundingClientRect().top -
        this.settings.offset,
      e =
        this.paginationElement.getBoundingClientRect().bottom +
        this.settings.offset;

    let a = this.nextPageLinkElement;
    let b = this.paginationElement.querySelector("a");
    let compare = a === b;
    t <= window.innerHeight &&
      e >= 0 &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
      this.removeScrollListener(),
      this.nextPageLinkElement &&
        ((this.nextPageLinkElement.innerHTML = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        this.loadMore()));
  }),
  (Ajaxinate.prototype.loadMore = function () {
    (this.request = new XMLHttpRequest()),
      (this.request.onreadystatechange = function () {
        if (4 === this.request.readyState && 200 === this.request.status) {
          var t = this.request.responseXML.querySelectorAll(this.settings.container)[0],
            e = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];

          // Remove banner-type items from the fetched page (collection image + any grid banners)
          t.querySelectorAll(".grid-collection-banner").forEach(function (el) {
            el.remove();
          });

          this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML);

          // >>> callback moved here — fires on EVERY loaded page, including the last
          this.settings.callback &&
            "function" == typeof this.settings.callback &&
            this.settings.callback(this.request.responseXML);

          new theme.QuickAdd(this.containerElement);
          const cardButton = this.containerElement.querySelectorAll(".product-form__submit-ajax");
          if (cardButton) {
            window.buttonAnimation(cardButton);
          }

          if (e === undefined) {
            document.querySelector("#pagination-wrapper").remove();
          } else {
            this.paginationElement.innerHTML = e.innerHTML;
            this.initialize();
          }
        }
      }.bind(this)),
      this.request.open("GET", this.nextPageUrl),
      (this.request.responseType = "document"),
      this.request.send();
  });
  (Ajaxinate.prototype.removeClickListener = function () {
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
  }),
  (Ajaxinate.prototype.removeScrollListener = function () {
    document.removeEventListener("scroll", this.checkIfPaginationInView),
      window.removeEventListener("resize", this.checkIfPaginationInView),
      window.removeEventListener(
        "orientationchange",
        this.checkIfPaginationInView
      );
  }),
  (Ajaxinate.prototype.destroy = function () {
    return (
      {
        click: this.removeClickListener,
        scroll: this.removeScrollListener,
      }[this.settings.method](),
      this
    );
  });
